<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge bottom color="success" overlap offset-x="12" offset-y="12" dot>
        <v-avatar size="30px" v-bind="attrs" v-on="on">
          <v-img
            v-if="profile && profile.base64Image"
            :src="`data:image/jpeg;base64,${profile.base64Image}`"
          ></v-img>
          <v-icon v-else>mdi-account-circle</v-icon>
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2 user-menu">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar size="30">
            <v-img
              v-if="user.profile && user.profile.base64Image"
              :src="`data:image/jpeg;base64,${user.profile.base64Image}`"
            ></v-img>
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align: middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ user.name }}
          </span>
          <small class="text--disabled text-capitalize">Student</small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile -->
      <v-list-item link :to="{ name: 'AccountSettings' }">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link :to="{ name: 'AccountSettings' }">
        <v-list-item-icon class="me-2">
          <v-icon size="22"> mdi-more </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>I Need Help</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!--      <v-list-item link>-->
      <!--        <v-list-item-icon class="me-2">-->
      <!--          <v-icon size="22"> mdi-bell-outline </v-icon>-->
      <!--        </v-list-item-icon>-->
      <!--        <v-list-item-content>-->
      <!--          <v-list-item-title>Notifications</v-list-item-title>-->
      <!--        </v-list-item-content>-->

      <!--        <v-list-item-action>-->
      <!--          <v-badge inline color="error" content="2"> </v-badge>-->
      <!--        </v-list-item-action>-->
      <!--      </v-list-item>-->

      <v-divider class="my-2"></v-divider>

      <!-- Settings -->
      <v-list-item link :to="{ name: 'AccountSettings' }">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCogOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Admission -->
      <v-list-item link :to="{ name: 'AdmissionLetter' }">
        <v-list-item-icon class="me-2">
          <v-icon size="22"> mdi-script </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Admission</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- FAQ -->
      <v-list-item link target="_blank" href="https://kiseb.or.ke/kiseb_faqs/">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiHelpCircleOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>FAQ</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <!-- Logout -->
      <v-list-item link @click="logout()">
        <v-list-item-icon class="me-2">
          <v-icon size="22"> {{ icons.mdiLogoutVariant }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiNotificationClearAll,
} from "@mdi/js";
import { AuthService } from "../../auth";

export default {
  name: "AccountProfileDropdown",
  props: {
    menus: {
      type: [],
    },
  },
  data() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiNotificationClearAll,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    };
  },
  computed: {
    bioData() {
      return AuthService.user.profile;
    },
    user() {
      return AuthService.user;
    },
    // using this profile from the API for responsive avatar!
    profile() {
      return this.$store.getters["Profile/bioData"];
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("Auth/logout");
    },
  },
};
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
    font-family: "PT Sans Caption", sans-serif;
    cursor: progress;
    width: 100%;
    margin: 0 auto;
  }
}
</style>
